import Vue from 'vue';
console.log('执行')
//初始化socket
var socket = new WebSocket("ws://121.41.8.168:2358");
socket.addEventListener('open', function(event) {
	console.log('连接成功');
});
socket.onclose = function(e) {
	console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
	console.log(e)
}
Vue.prototype.$http = socket
